import { ICountry, ILocation, IPaymentFields, ISteps, RootState } from '@checkout/state';
import { Field } from 'formik';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { AddressForm, ContactDetailsForm } from '..';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import { changeStepRequest } from '../../../reducers/checkout';
import { isAddressAvailable, isOnlyOneCountry } from '../../../utils/address';
import { FormNames } from '../../../utils/formNames';
// import { isKlarnaCheckout, isPaypal } from '../../../utils/paymentMethods';
import { GroupTitle, InputBoxField, Section } from '../../presentational';
import messages from './../../../i18n/base-en';

interface IOwnProps {
  readOnly?: boolean;
  disableCountryStateFields?: boolean;
}

interface IConnectedProps {
  steps: ISteps;
  paymentFields: IPaymentFields;
  location: ILocation;
  countries: ICountry[];
  paymentMethod: string;
}

interface IConnectetDispatchProps {
  changeStepRequest: typeof changeStepRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class PersonalInformation extends React.Component<Props, {}> {

  changeStep = (isValid: boolean) => {
    if (isValid) {
      this.props.changeStepRequest({ step: this.props.steps.current + 1 });
    }
  }

  render() {
    const { paymentFields, readOnly, countries, location, disableCountryStateFields, intl } = this.props;
    const { formatMessage } = intl;

    if (!paymentFields || !paymentFields.address || !paymentFields.shippingAddress) { return null; }

    const isOnlyCountryVisible = Object.keys(paymentFields.address).filter((fieldKey: string) =>
      paymentFields.address[fieldKey].visible).filter((fieldKey: string) => fieldKey !== 'state' && fieldKey !== 'newsletter').length === 1;
    const showAddressSection = isAddressAvailable(paymentFields.address) && !(isOnlyCountryVisible && disableCountryStateFields);
    // const hideAddress = isPaypal(paymentMethod) || isKlarnaCheckout(paymentMethod);
    const isContactInformationAvailable = paymentFields &&
      paymentFields.address &&
      paymentFields.address.email.visible &&
      paymentFields.address.phoneNumber.visible;

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <Fragment>
            {showAddressSection && !isOnlyOneCountry(countries) && (
              <Section blockFor="PersonalInformation">
                <GroupTitle title={formatMessage(messages.customer_information_group_title)} accent={true} variant="big" />
                {!isOnlyOneCountry(countries) && (
                  <Section spacingBottom="no" readOnly={readOnly} blockFor="AddressForm">
                    <GroupTitle title={formatMessage(messages.shipping_address_group_title)} readOnly={readOnly} />
                    <AddressForm
                      isActive={true}
                      location={location}
                      fields={paymentFields.address}
                      formName={FormNames.shippingAddress}
                      disableCountryStateFields={disableCountryStateFields}
                      readOnly={readOnly}
                    />
                  </Section>
                )}
                {isContactInformationAvailable && (
                  <Section readOnly={readOnly} blockFor="ContactDetailsForm">
                    <GroupTitle title={formatMessage(messages.contact_group_title)} readOnly={readOnly} />
                    <ContactDetailsForm
                      fields={paymentFields.shippingAddress}
                      formName={FormNames.contactDetails}
                      readOnly={readOnly}
                    />
                  </Section>
                )}
                {!readOnly && isContactInformationAvailable && checkoutContextConfig.ui.personalInformation.isRememberMeVisible && (
                  <Section spacingBottom="half" blockFor="RememberMe">
                    <Field
                      id="rememberMe"
                      name="rememberMe"
                      component={InputBoxField}
                      semanticType="checkbox"
                      label={formatMessage(messages.remember_me_label)}
                    />
                  </Section>
                )}
              </Section>
            )}
          </Fragment>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  steps: state.checkout.steps,
  paymentFields: state.checkout.paymentFields,
  location: state.checkout.location,
  countries: state.checkout.countries,
  paymentMethod: state.checkout.selection.paymentMethod
});

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    mapStateToProps,
    {
      changeStepRequest
    },
  )
)(PersonalInformation);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/PersonalInformation/PersonalInformation.tsx